import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../sale/sale.css";
import Button from "react-bootstrap/Button";
import { IconButton } from "@material-ui/core";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Select from "react-select";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";

import TextField from "@mui/material/TextField";
import Red_toast from "../alerts/red_toast";
import InputGroup from "react-bootstrap/InputGroup";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { faListOl } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from "react-toastify";

import success_toast from "../alerts/success_toast";
import Tooltip from "@material-ui/core/Tooltip";
import Customerform from "../customers/customerform";
import Productform from "../products/productform";
import Saleform from "../sale/saleform";
import Notesmodel from "../sale/notemodel";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import Save_button from "../buttons/save_button";
import { useTranslation } from "react-i18next";

function Quotation(props) {
  const user = props.state.setuser.user;
  const route = props.state.setuser.route;
  const { t } = useTranslation();
  const selected_branch = props.state.Setcurrentinfo.selected_branch;
  const current_user = props.state.Setcurrentinfo.current_user;
  const check_status = props.state.Settablehistory.table_history;
  const dispatch = props.Settable_history;

  const table_data = props.state.Setproducthistory.product_history;
  const settable_data = props.Setproduct_history;
  const [deliveryman, setdeliveryman] = useState("");

  const [saleman, setsaleman] = useState("");

  const [all_product_option, setall_product_option] = useState([]);
  const [all_product, setall_product] = useState([]);
  const [all_suppliers, setall_suppliers] = useState([]);
  const [placeholder, setplaceholder] = useState(t("search_by_name"));
  const [name_color, setname_color] = useState("blue");
  const [barcode_color, setbarcode_color] = useState("lightgray");
  const [code_color, setcode_color] = useState("lightgray");
  const [text, settext] = useState("");
  const [url, seturl] = useState("");
  const [status, setstatus] = useState("false");

  var curr = new Date();
  var curdate = curr.toISOString().substring(0, 10);
  const [invoice, setinvoice] = useState("");
  const [date, setdate] = useState(curdate);
  const [validdate, setvaliddate] = useState(null);
  const [counter, setcounter] = useState(1);
  const [supplier, setsupplier] = useState("");
  const [payment_type, setpayment_type] = useState("");

  const [subtotal, setsubtotal] = useState(0);
  const [vat, setvat] = useState(0);
  const [discount, setdiscount] = useState(0);
  const [extra_discount, setextra_discount] = useState(0);
  const [total, settotal] = useState(0);
  const [vat_perc, setvat_perc] = useState(0);
  const [notes, setnotes] = useState("");
  const [showmodelsuplier, setshowmodelsuplier] = useState(false);
  const [showmodelproduct, setshowmodelproduct] = useState(false);
  const [showmodel, setshowmodel] = useState(false);
  const [notemodel, setnotemodel] = useState(false);
  const [isloading, setisloading] = useState(false);
  const [showpayment_model, setshowpayment_model] = useState(false);
  const [print, setprint] = useState(false);
  const [getlatest_invoice, setgetlatest_invoice] = useState(false);
  const [product, setproduct] = useState("");
  const [suppliers_data, setsuppliers_data] = useState([]);
  const [data, setdata] = useState("");
  const [text_product, settext_product] = useState("");
  const [payment_terms, setpayment_terms] = useState("");
  const [delivery_date, setdelivery_date] = useState(curdate);

  useEffect(() => {
    dispatch({ type: "Set_menuitem", data: "quotation" });
  }, []);
  useEffect(() => {
    const fetchlatest_invoice = async () => {
      const response = await fetch(
        `${route}/api/quotation/${selected_branch.id}/latest-quotation/`,
        {
          headers: { Authorization: `Bearer ${user.access}` },
        }
      );
      const json = await response.json();

      if (response.ok) {
        setinvoice(json.quotation_number);
      }
      if (!response.ok) {
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }
    };

    fetchlatest_invoice();
  }, [selected_branch, getlatest_invoice]);

  useEffect(() => {
    settable_data({ type: "Set_product_history", data: [] });
    const fetchProducts = async () => {
      const response = await fetch(
        `${route}/api/products/?branch_id=${selected_branch.id}`,
        {
          headers: { Authorization: `Bearer ${user.access}` },
        }
      );
      const json = await response.json();

      if (response.ok) {
        setall_product(json);
        const pro = json.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
        setall_product_option(pro);
      }
      if (!response.ok) {
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }
    };

    if (user) {
      fetchProducts();
    }
  }, [user, selected_branch, check_status]);

  useEffect(() => {
    if (invoice && supplier && validdate && table_data.length > 0) {
      setprint(true);
    } else {
      setprint(false);
    }
  }, [invoice, validdate, supplier, table_data]);

  useEffect(() => {
    const fetchSuppliers = async () => {
      const response = await fetch(
        `${route}/api/parties/?branch_id=${selected_branch.id}&party_type=Customer`,
        {
          headers: { Authorization: `Bearer ${user.access}` },
        }
      );
      const json = await response.json();

      if (response.ok) {
        setsuppliers_data(json);
        const supp = json.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
        setall_suppliers(supp);
        setsupplier(supp.slice(-1)[0]);
      }
      if (!response.ok) {
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }
    };

    if (user) {
      fetchSuppliers();
    }
  }, [user, selected_branch, check_status]);

  useEffect(() => {
    const fetchcompany = async () => {
      const response = await fetch(
        `${route}/api/branch/${selected_branch.id}/`,
        {
          headers: { Authorization: `Bearer ${user.access}` },
        }
      );
      const json = await response.json();

      if (response.ok) {
        setvat_perc(json.vat_percentage);
      }
    };
    if (user) {
      fetchcompany();
    }
  }, [selected_branch]);

  useEffect(() => {
    var vat_total = 0;
    var subtotal_total = 0;
    var discount_total = 0;
    var total_total = 0;
    table_data.forEach((item) => {
      vat_total += Number(item.vat_amount);
      subtotal_total += Number(item.sub_total);
      discount_total += Number(item.discount);
      total_total += Number(item.total);
    });
    setsubtotal(subtotal_total.toFixed(2));
    setvat(vat_total.toFixed(2));
    setdiscount(discount_total.toFixed(2));
    settotal((total_total - extra_discount).toFixed(2));
  }, [table_data]);

  useEffect(() => {
    var repeat_total = 0;
    table_data.forEach((item) => {
      repeat_total += Number(item.total);
    });
    settotal((repeat_total - extra_discount).toFixed(2));
  }, [extra_discount]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selected_branch) {
      setisloading(true);
      const data_details = table_data.map((item) => {
        delete item["prod_id"];
        delete item["name"];
        delete item["code"];
        return item;
      });

      console.log(data_details);
      setisloading(true);

      const response = await fetch(`${route}/api/quotation/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.access}`,
        },
        body: JSON.stringify({
          user: current_user.id,
          branch: selected_branch.id,
          customer: supplier.value,
          remarks: notes,
          date: date,
          valid_date: validdate,
          quotation_number: invoice,
          sub_total: subtotal,
          vat_amount: vat,
          discount: discount,
          extra_disc: extra_discount,
          total: total,
          vat_percentage: vat_perc,
          status: "pending",
          details: data_details,
          delivery_date: delivery_date,
          payment_terms: payment_terms,
        }),
      });
      const json = await response.json();

      if (!response.ok) {
        setisloading(false);
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }

      if (response.ok) {
        setisloading(false);
        success_toast();
        settable_data({ type: "Set_product_history", data: [] });
        setvaliddate("");
        setsupplier("");
        setsubtotal(0);
        setvat_perc(0);
        setvat(0);
        setdiscount(0);
        setextra_discount(0);
        settotal(0);
        setgetlatest_invoice(!getlatest_invoice);
        setprint(false);
        setnotes("");
        setpayment_terms("");
        setdelivery_date(curdate);
      }
    }
  };

  const handleNewSale = (e) => {
    e.preventDefault();
    settable_data({ type: "Set_product_history", data: [] });
    setvaliddate("");
    setsupplier("");
    setsubtotal(0);
    setvat_perc(0);
    setvat(0);
    setdiscount(0);
    setextra_discount(0);
    settotal(0);
    setprint(false);
    setdelivery_date(curdate);
    setpayment_terms("");
  };

  const handlePrint = async () => {
    if (selected_branch) {
      const data_details = table_data.map((item) => {
        delete item["prod_id"];
        delete item["name"];
        delete item["code"];
        return item;
      });

      const response = await fetch(`${route}/api/quotation/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.access}`,
        },
        body: JSON.stringify({
          user: current_user.id,
          branch: selected_branch.id,
          customer: supplier.value,
          remarks: notes,
          date: date,
          valid_date: validdate,
          quotation_number: invoice,
          sub_total: subtotal,
          vat_amount: vat,
          discount: discount,
          extra_disc: extra_discount,
          total: total,
          vat_percentage: vat_perc,
          status: "pending",
          details: data_details,
          delivery_date: delivery_date,
          payment_terms: payment_terms,
        }),
      });
      const json = await response.json();

      if (!response.ok) {
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }

      if (response.ok) {
        localStorage.setItem("data", JSON.stringify(json));
        settable_data({ type: "Set_product_history", data: [] });
        setnotes("");
        setvaliddate("");
        setsupplier("");
        setsubtotal(0);
        setvat_perc(0);
        setvat(0);
        setdiscount(0);
        setextra_discount(0);
        settotal(0);
        setgetlatest_invoice(!getlatest_invoice);
        setpayment_terms("");
        setdelivery_date(curdate);
        setprint(false);
        if (selected_branch.invoice_type === "Version 01") {
          window.open("/invoice/quotation", "_blank");
        } else if (selected_branch.invoice_type === "Version 02") {
          window.open("/invoice_2/quotation", "_blank");
        } else if (selected_branch.invoice_type === "Version 03") {
          window.open("/invoice_3/quotation", "_blank");
        } else if (selected_branch.invoice_type === "Version 04") {
          window.open("/invoice_5/quotation", "_blank");
        } else if (selected_branch.invoice_type === "Version 05") {
          window.open("/invoice_6/quotation", "_blank");
        } else if (selected_branch.invoice_type === "Version 06") {
          window.open("/invoice_7/quotation", "_blank");
        }
      }
    }
  };

  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div className="action text-center">
        <IconButton
          onClick={() => {
            settable_data({ type: "Delete_product_history", data: row });
          }}
        >
          <DeleteRoundedIcon color="error" fontSize="medium" />
        </IconButton>
      </div>
    );
  };

  const headerstyle = (column, colIndex, { sortElement }) => {
    return (
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ minHeight: "2.5rem" }}
      >
        {column.text}
        {sortElement}
      </div>
    );
  };

  const name_column_formater = (cell, row) => {
    return <div style={{ width: "18vw" }}>{cell}</div>;
  };

  const fix_formatter = (cell, row) => {
    return <div>{parseFloat(cell).toFixed(2)}</div>;
  };

  const columns = [
    {
      dataField: "row_number",
      text: "#",
      headerFormatter: headerstyle,
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      editable: false,
    },
    {
      dataField: "code",
      text: t("code"),
      headerFormatter: headerstyle,
      editable: false,
    },
    {
      dataField: "name",
      text: t("name"),
      sort: true,
      headerFormatter: headerstyle,
      formatter: name_column_formater,
      editable: false,
    },
    { dataField: "quantity", text: t("qty"), headerFormatter: headerstyle },
    {
      dataField: "price",
      text: t("price"),
      headerFormatter: headerstyle,
      formatter: fix_formatter,
    },
    {
      dataField: "sub_total",
      text: t("subtotal"),
      headerFormatter: headerstyle,
      formatter: fix_formatter,
      editable: false,
    },
    {
      dataField: "vat_percentage",
      text: t("vat%"),
      headerFormatter: headerstyle,
      formatter: fix_formatter,
    },
    {
      dataField: "vat_amount",
      text: t("vat_amount"),
      headerFormatter: headerstyle,
      formatter: fix_formatter,
      editable: false,
    },
    {
      dataField: "discount",
      text: t("discount"),
      headerFormatter: headerstyle,
      formatter: fix_formatter,
    },
    {
      dataField: "total",
      text: t("total"),
      headerFormatter: headerstyle,
      formatter: fix_formatter,
      editable: false,
    },
    {
      dataField: "Edit",
      text: t("action"),
      formatter: linkFollow,
      headerFormatter: headerstyle,
      editable: false,
    },
  ];

  const handlesearch_by_barcode = () => {
    const pro = all_product.map((item) => {
      return {
        value: item.id,
        label: item.barcode,
      };
    });
    setall_product_option(pro);
    setplaceholder(t("search_by_barcode"));
    setbarcode_color("blue");
    setname_color("lightgray");
    setcode_color("lightgray");
  };
  const handlesearch_by_code = () => {
    const pro = all_product.map((item) => {
      return {
        value: item.id,
        label: `${item.code} | ${item.name} `,
      };
    });
    setall_product_option(pro);
    setplaceholder(t("search_by_code"));
    setbarcode_color("lightgray");
    setname_color("lightgray");
    setcode_color("blue");
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };

  const handlesearch_by_name = () => {
    const pro = all_product.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
    setall_product_option(pro);
    setplaceholder(t("search_by_name"));
    setbarcode_color("lightgray");
    setname_color("blue");
    setcode_color("lightgray");
  };

  const handlebarcodeinput = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      console.log(e.target.value);
      const filter_data = all_product.filter((item) => {
        if (item.barcode === e.target.value) {
          return item;
        }
      });
      if (filter_data.length > 0) {
        handleproduct_selection({
          value: filter_data[0].id,
          label: filter_data[0].name,
        });
      }
      settext_product("");
    }
  };

  const handleproduct_selection = (selected_option) => {
    const item_present = table_data.filter((item) => {
      return item.product === selected_option.value;
    });

    if (item_present.length === 0) {
      var filter_data = all_product.filter((item) => {
        if (item.id === selected_option.value) {
          return item;
        }
      });

      filter_data = filter_data.map((item) => {
        return {
          product: item.id,
          prod_id: counter,
          name: item.name,
          code: item.code,
          quantity: 1,
          price: item.price,
          sub_total: item.price,
          vat_percentage: vat_perc,
          vat_amount: (item.price / 100) * vat_perc,
          discount: 0,
          total: item.price + (item.price / 100) * vat_perc,
        };
      });
      settable_data({ type: "Create_product_history", data: filter_data[0] });
      setcounter(counter + 1);
    } else {
      const item = item_present[0];
      item.quantity = item.quantity + 1;
      item.sub_total = item.quantity * item.price;
      item.vat_amount = (item.sub_total / 100) * item.vat_percentage;
      item.total = item.sub_total + item.vat_amount - item.discount;
      settable_data({ type: "Update_product_history", data: item });
    }
  };

  const handlecellchange = (oldValue, newValue, row, column) => {
    console.log("row", row);
    if (column.dataField === "quantity") {
      var new_data = table_data.map((item) => {
        return item.product !== row.product
          ? item
          : {
              product: item.product,
              prod_id: item.prod_id,
              name: item.name,
              code: item.code,
              quantity: newValue,
              price: item.price,
              sub_total: item.price * newValue,
              vat_percentage: item.vat_percentage,
              vat_amount: ((item.price * newValue) / 100) * item.vat_percentage,
              discount: item.discount,
              total:
                item.price * newValue +
                ((item.price * newValue) / 100) * item.vat_percentage -
                item.discount,
            };
      });
      settable_data({ type: "Set_product_history", data: new_data });
    } else if (column.dataField === "vat_percentage") {
      console.log("vat_percentage");
      new_data = table_data.map((item) => {
        return item.product !== row.product
          ? item
          : {
              product: item.product,
              prod_id: item.prod_id,
              name: item.name,
              code: item.code,
              quantity: item.quantity,
              price: item.price,
              sub_total: item.sub_total,
              vat_percentage: newValue,
              vat_amount: (item.sub_total / 100) * newValue,
              discount: item.discount,
              total:
                item.sub_total +
                (item.sub_total / 100) * newValue -
                item.discount,
            };
      });
      settable_data({ type: "Set_product_history", data: new_data });
    } else if (column.dataField === "discount") {
      console.log("discount");
      new_data = table_data.map((item) => {
        return item.product !== row.product
          ? item
          : {
              product: item.product,
              prod_id: item.prod_id,
              name: item.name,
              code: item.code,
              quantity: item.quantity,
              price: item.price,
              sub_total: item.sub_total,
              vat_percentage: item.vat_percentage,
              vat_amount: item.vat_amount,
              discount: newValue,
              total: item.sub_total + item.vat_amount - newValue,
            };
      });
      console.log(new_data);
      settable_data({ type: "Set_product_history", data: new_data });
    } else if (column.dataField === "price") {
      new_data = table_data.map((item) => {
        return item.product !== row.product
          ? item
          : {
              product: item.product,
              prod_id: item.prod_id,
              name: item.name,
              code: item.code,
              quantity: item.quantity,
              price: newValue,
              sub_total: newValue * item.quantity,
              vat_percentage: item.vat_percentage,
              vat_amount:
                ((newValue * item.quantity) / 100) * item.vat_percentage,
              discount: item.discount,
              total:
                newValue * item.quantity +
                ((newValue * item.quantity) / 100) * item.vat_percentage -
                item.discount,
            };
      });

      settable_data({ type: "Set_product_history", data: new_data });
    }
  };

  const handlevat_percentage = (e) => {
    const vat_value = e.target.value;
    setvat_perc(vat_value);
    if (table_data) {
      console.log("ok");
      const new_data = table_data.map((item) => {
        return {
          product: item.product,
          prod_id: item.prod_id,
          name: item.name,
          code: item.code,
          quantity: item.quantity,
          price: item.price,
          sub_total: item.sub_total,
          vat_percentage: vat_value,
          vat_amount: (item.sub_total / 100) * vat_value,
          discount: item.discount,
          total:
            item.sub_total + (item.sub_total / 100) * vat_value - item.discount,
        };
      });
      settable_data({ type: "Set_product_history", data: new_data });
    }
  };

  return (
    <>
      {current_user?.permissions?.includes("add_quotation") ? (
        <div className="p-3">
          <h1
            className="mb-3"
            style={{ fontSize: "1.8rem", fontWeight: "normal" }}
          >
            {t("side_bar_quotation")}
          </h1>
          <ToolkitProvider
            keyField="prod_id"
            data={table_data}
            columns={columns}
            search
            exportCSV
          >
            {(props) => (
              <div className="card">
                <form onSubmit={handleSubmit}>
                  <div className="card-header  d-flex justify-content-end">
                    <Button
                      className="me-2"
                      type="button"
                      variant="outline-dark"
                      onClick={handleNewSale}
                    >
                      <AddIcon /> {t("new")}{" "}
                    </Button>

                    <Save_button isloading={isloading} />
                    {print ? (
                      <Button
                        className="ms-2"
                        variant="outline-success"
                        onClick={handlePrint}
                      >
                        <PrintRoundedIcon /> {t("print")}
                      </Button>
                    ) : (
                      <Button
                        className="ms-2"
                        variant="outline-success"
                        disabled
                      >
                        <PrintRoundedIcon /> {t("print")}
                      </Button>
                    )}
                  </div>

                  <div className="card-body ">
                    <div className="row mt-1">
                      <div className="col-6 mb-2 col-md-2">
                        <TextField
                          type="date"
                          className="form-control   mb-3"
                          id="outlined-basic"
                          label={t("date")}
                          InputLabelProps={{ shrink: true }}
                          defaultValue={date}
                          value={date}
                          onChange={(e) => {
                            setdate(e.target.value);
                          }}
                          size="small"
                        />
                      </div>

                      <div className="col-6 mb-2 col-md-2">
                        <TextField
                          type="date"
                          className="form-control   mb-3"
                          id="outlined-basic"
                          label={t("delivery_date")}
                          InputLabelProps={{ shrink: true }}
                          value={delivery_date}
                          onChange={(e) => {
                            setdelivery_date(e.target.value);
                          }}
                          size="small"
                        />
                      </div>

                      <div className="col-6 mb-2 col-md-2">
                        <TextField
                          type="date"
                          className="form-control   mb-3"
                          id="outlined-basic"
                          label={t("valid_date")}
                          InputLabelProps={{ shrink: true }}
                          value={validdate}
                          onChange={(e) => {
                            setvaliddate(e.target.value);
                          }}
                          size="small"
                          required
                        />
                      </div>

                      <div className="col-6 mb-2 col-md-2">
                        <TextField
                          className="form-control   mb-3"
                          id="outlined-basic"
                          label={t("quotation_number")}
                          value={invoice}
                          size="small"
                          required
                        />
                      </div>

                      <div className="col-6 mb-2 col-md-2">
                        <InputGroup>
                          <Select
                            className={
                              supplier
                                ? selected_branch.language === "English"
                                  ? "form-control selector customer"
                                  : "form-control selector customer_ar"
                                : "form-control selector"
                            }
                            styles={selectStyles}
                            options={all_suppliers}
                            placeholder="Customers"
                            value={supplier}
                            onChange={(e) => {
                              setsupplier(e);
                            }}
                            required
                          ></Select>

                          <IconButton
                            className="p-0 ps-1 pe-1"
                            style={{
                              backgroundColor: "#0d6efd",
                              borderRadius: "0",
                            }}
                            onClick={() => {
                              settext(t("side_bar_customers"));
                              seturl(
                                `${route}/api/parties/?branch_id=${selected_branch.id}&party_type=Customer`
                              );
                              setshowmodel(!showmodel);
                              setdata(suppliers_data);
                            }}
                          >
                            <VisibilityIcon
                              style={{ color: "white", height: "fit-content" }}
                              fontSize="medium"
                            />
                          </IconButton>
                          <IconButton
                            className="p-0 ps-1 pe-1"
                            style={{
                              backgroundColor: "slategray",
                              borderRadius: "0",
                            }}
                            onClick={() =>
                              setshowmodelsuplier(!showmodelsuplier)
                            }
                          >
                            <AddIcon
                              style={{ color: "white", height: "fit-content" }}
                              fontSize="medium"
                            />
                          </IconButton>
                        </InputGroup>
                      </div>

                      <div className="col-6 mb-2 col-md-2">
                        <TextField
                          type="text"
                          className="form-control   mb-3"
                          id="outlined-basic"
                          label={t("payment_terms")}
                          value={payment_terms}
                          onChange={(e) => {
                            setpayment_terms(e.target.value);
                          }}
                          size="small"
                        />
                      </div>
                    </div>

                    <div className="row mt-2 d-sm-flex justify-content-center align-items-center">
                      <div className="col-md-6 d-sm-flex align-items-center">
                        <div className="text-center me-3">
                          <Tooltip title={t("search_by_barcode")}>
                            <IconButton onClick={handlesearch_by_barcode}>
                              <FontAwesomeIcon
                                color={barcode_color}
                                icon={faBarcode}
                                size="lg"
                              />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title={t("search_by_code")}>
                            <IconButton onClick={handlesearch_by_code}>
                              <FontAwesomeIcon
                                color={code_color}
                                icon={faListOl}
                                size="lg"
                              />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title={t("search_by_name")}>
                            <IconButton onClick={handlesearch_by_name}>
                              <FontAwesomeIcon
                                color={name_color}
                                icon={faTag}
                                size="lg"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <div className="col-md-8 p-0">
                          <InputGroup>
                            {barcode_color === "lightgray" ? (
                              <Select
                                className="form-control selector"
                                placeholder={placeholder}
                                options={all_product_option}
                                value={product}
                                onChange={handleproduct_selection}
                              ></Select>
                            ) : (
                              <TextField
                                className="form-control"
                                id="outlined-basic"
                                label={t("search_by_barcode")}
                                onKeyDown={handlebarcodeinput}
                                value={text_product}
                                onChange={(e) =>
                                  settext_product(e.target.value)
                                }
                                size="small"
                              />
                            )}

                            <IconButton
                              className="p-0 ps-1 pe-1"
                              style={{
                                backgroundColor: "#0d6efd",
                                borderRadius: "0",
                              }}
                              onClick={() => {
                                settext(t("side_bar_product"));
                                seturl(
                                  `${route}/api/products/?branch_id=${selected_branch.id}`
                                );
                                setshowmodel(!showmodel);
                                setdata(all_product);
                              }}
                            >
                              <VisibilityIcon
                                style={{
                                  color: "white",
                                  height: "fit-content",
                                }}
                                fontSize="medium"
                              />
                            </IconButton>
                            <IconButton
                              className="p-0 ps-1 pe-1"
                              style={{
                                backgroundColor: "slategray",
                                borderRadius: "0",
                              }}
                              onClick={() =>
                                setshowmodelproduct(!showmodelproduct)
                              }
                            >
                              <AddIcon
                                style={{
                                  color: "white",
                                  height: "fit-content",
                                }}
                                fontSize="medium"
                              />
                            </IconButton>
                          </InputGroup>
                        </div>
                      </div>
                      <div className="col-md-1 p-3 p-sm-0">
                        <Button
                          type="button"
                          variant="outline-dark"
                          onClick={() => setnotemodel(!notemodel)}
                        >
                          {" "}
                          {t("notes")}
                        </Button>
                      </div>
                    </div>

                    <hr />
                    <div style={{ height: "45vh", overflow: "auto" }}>
                      <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        bootstrap4
                        condensed
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: handlecellchange,
                        })}
                        rowClasses="custom_row_class"
                      />
                    </div>
                  </div>
                  <div className="card-footer d-flex justify-content-end">
                    <div className="me-3">
                      <TextField
                        type="number"
                        className="form-control"
                        id="outlined-basic"
                        label={t("subtotal")}
                        value={subtotal}
                        onChange={(e) => {
                          setsubtotal(e.target.value);
                        }}
                        size="small"
                        disabled
                      />
                    </div>

                    <div className="me-3">
                      <TextField
                        type="number"
                        className="form-control"
                        id="outlined-basic"
                        label={t("vat%")}
                        value={vat_perc}
                        onChange={handlevat_percentage}
                        size="small"
                      />
                    </div>
                    <div className="me-3">
                      <TextField
                        type="number"
                        className="form-control"
                        id="outlined-basic"
                        label={t("vat_amount")}
                        value={vat}
                        onChange={(e) => {
                          setvat(e.target.value);
                        }}
                        size="small"
                        disabled
                      />
                    </div>
                    <div className="me-3">
                      <TextField
                        className="form-control "
                        id="outlined-basic"
                        label={t("discount")}
                        value={discount}
                        onChange={(e) => {
                          setdiscount(e.target.value);
                        }}
                        size="small"
                        disabled
                      />{" "}
                    </div>
                    <div className="me-3">
                      <TextField
                        type="number"
                        className="form-control "
                        id="outlined-basic"
                        label={t("extra_discount")}
                        value={extra_discount}
                        onChange={(e) => {
                          setextra_discount(e.target.value);
                        }}
                        size="small"
                      />{" "}
                    </div>
                    <div className="me-3">
                      <TextField
                        type="number"
                        className="form-control "
                        id="outlined-basic"
                        label={t("total")}
                        value={total}
                        onChange={(e) => {
                          settotal(e.target.value);
                        }}
                        size="small"
                        disabled
                      />
                    </div>
                  </div>

                  <ToastContainer
                    autoClose={1000}
                    hideProgressBar={true}
                    theme="dark"
                  />
                </form>
              </div>
            )}
          </ToolkitProvider>

          {showmodelsuplier && (
            <Customerform
              show={showmodelsuplier}
              onHide={() => setshowmodelsuplier(false)}
              user={user}
              route={route}
              callback={dispatch}
              selected_branch={selected_branch}
              check="true"
            />
          )}

          {showmodelproduct && (
            <Productform
              show={showmodelproduct}
              onHide={() => setshowmodelproduct(false)}
              user={user}
              route={route}
              callback={dispatch}
              selected_branch={selected_branch}
              check="true"
            />
          )}

          {showmodel && (
            <Saleform
              show={showmodel}
              onHide={() => setshowmodel(false)}
              user={user}
              route1={url}
              callback={settable_data}
              text={text}
              counter={counter}
              setcounter={setcounter}
              setsupplier={setsupplier}
              setdeliveryman={setdeliveryman}
              setsaleman={setsaleman}
              table_data={table_data}
              vat_perc={vat_perc}
              selected_branch={selected_branch}
              route={route}
              data_={data}
            />
          )}
          {notemodel && (
            <Notesmodel
              show={notemodel}
              onHide={() => setnotemodel(false)}
              notes={notes}
              setnotes={setnotes}
            />
          )}
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "30px",
            fontWeight: "bold",
            opacity: "0.7",
          }}
        >
          No Page Found
        </div>
      )}
    </>
  );
}

export default Quotation;
